import { put, call } from "redux-saga/effects";
// import get_api from "../../../../../lib/LockerSettings/GetApi";
import get_api from "../api/GetApi";
import { changeBranchViewAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getChangeBranchInfoData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getVeiwInfo, param);

    if (data.data === null) {
      yield put(changeBranchViewAction.loadChangeBranchViewSuccess(false));
    } else {
      yield put(changeBranchViewAction.loadChangeBranchViewSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(changeBranchViewAction.loadChangeBranchViewFail(error));
    yield put(globalFinishLoading());
  }
}
